import { render, staticRenderFns } from "./TransactionCopyable.vue?vue&type=template&id=7b82d557&scoped=true&"
import script from "./TransactionCopyable.vue?vue&type=script&lang=js&"
export * from "./TransactionCopyable.vue?vue&type=script&lang=js&"
import style0 from "./TransactionCopyable.vue?vue&type=style&index=0&id=7b82d557&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b82d557",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VHover,VIcon,VTooltip})
